import MaterialLoader from "../../../output/assets/materials/material-loader.js";

class GLRaycastBaseMaterial {
    constructor(loader, propAssigner, ownerAssigner) {
        this._loader = loader;
        this._propAssigner = propAssigner;
        this._ownerAssigner = ownerAssigner;

        this._properties = Object.seal({
            side: THREE.FrontSide,
            skinning: false,
            morphTargets: false,
        });

        this._materials = new Map();
    }

    dispose() {
        for (const [owner, { material }] of this._materials) {
            this._loader.unload(material);
        }
    }

    makeMaterial(owner) {
        let mat = this._materials.get(owner);

        if (!mat) {
            const material = this._loader.load();
            mat = { material, count: 0 };
            this._ownerAssigner.setProperty(material, owner);

            for (const property in this._properties) {
                const value = this._properties[property];
                this._propAssigner.setProperty(material, property, value);
            }

            this._materials.set(owner, mat);
        }

        mat.count++;

        return mat.material;
    }

    freeMaterial(owner) {
        const mat = this._materials.get(owner);
        mat.count--;

        if (mat.count === 0) {
            this._loader.unload(mat.material);
            this._materials.delete(owner);
        }
    }

    setProperty(property, value) {
        this._properties[property] = value;

        for (const [owner, { material }] of this._materials) {
            this._propAssigner.setProperty(material, property, value);
        }
    }
}

class ThreeGLRaycastBaseMaterialLoader extends MaterialLoader {
    constructor(loader, propAssigner, ownerAssigner) {
        super();

        this._loader = loader;
        this._propAssigner = propAssigner;
        this._ownerAssigner = ownerAssigner;
    }

    load() {
        return new GLRaycastBaseMaterial(this._loader, this._propAssigner, this._ownerAssigner);
    }

    unload(material) {
        material.dispose();
    }
}

export default ThreeGLRaycastBaseMaterialLoader;
